/**
 * Stable CSS class names for E2E — Add user to group dialog.
 */
export const GUED = {
    dialog: 'group-user-edit-dialog',
    title: 'group-user-edit-dialog__title',
    content: 'group-user-edit-dialog__content',
    actions: 'group-user-edit-dialog__actions',

    operatorAutocompleteWrap: 'group-user-edit-dialog-input__operator-autocomplete-wrap',

    addButton: 'group-user-edit-dialog-input--button-add',
    cancelButton: 'group-user-edit-dialog-input--button-cancel',
} as const;

export const guedCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

